module.exports = "<mc-notification-icon \n    *ngIf=\"recommendation$ | async \"\n    [text]=\"recommendation$ | async\">\n</mc-notification-icon>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/template/recommendation-count/recommendation-count.component.html
// module id = ../../../../../src/app/core/template/recommendation-count/recommendation-count.component.html
// module chunks = 10